import Konva from 'konva';
import React from 'react';
import { Rect } from 'react-konva';
import { DateNumber } from 'types/global';
import { GraphStyle } from '../types';
import { xFromTimeStyled } from '../utils';


function DaySelect({
	start,		// data di riferimento
	select,		// la data che deve essere selezionata in relzione a "start"
	height,
	type,
	style,
	...props
}: DaySelectProps) {

	if (start == null || select == null) return null
	const xFromTime = xFromTimeStyled(style, start)
	const offset = xFromTime(select)
	if (offset < 0) return null

	return (
		<Rect listening={false}
			x={offset + .5}
			width={style.space.x}
			height={height}
			{...props}
		/>
	)
}

export default DaySelect

type DaySelectProps = {
	/** La data visibile a sinsitra nel PLANNER */
	start: DateNumber,
	/** la data che deve essere selezionata in relzione a "start" */
	select: DateNumber,
	/** altezza totale della barra */
	height: number,
	style: GraphStyle,
} & Konva.NodeConfig

